module.exports = __webpack_public_path__ + "static/img/u=497158095,3911612559&fm=26&gp=0.f9d9e89.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/logo/u=497158095,3911612559&fm=26&gp=0.jpg
// module id = YAjI
// module chunks = 0